import React, { FC } from 'react';
import * as classes from './AccordionItem.module.scss';
import cn from 'classnames';
import { AccordionItemI } from '../../../../../../interfaces/AccordionItemI';
import ArrowTop from '../../../../../../assets/icons/inline/arrow-top-light.inline.svg';

interface Props extends AccordionItemI {
  action: (id: string) => void;
  isActive: boolean;
  afterComponent?: JSX.Element;
}

const AccordionItem: FC<Props> = ({ description, title, id, action, isActive, afterComponent }) => {
  return (
    <div className={cn(classes.wrapper)}>
      <div className={cn(classes.heading, isActive && classes.isActive)} onClick={() => action(id)}>
        <div className={classes.title}>{title}</div>
        <div className={cn(classes.icon, isActive && classes.isActive)}>
          <ArrowTop />
        </div>
      </div>
      <div className={cn(classes.description, isActive && classes.isOpen)}>
        <div className={classes.innerDescription}>{description}</div>
        {afterComponent}
      </div>
    </div>
  );
};

export default AccordionItem;
